import {
    START_CUSTOMERSSHORTNAMEANDCODE_FLOW,
    START_CUSTOMERSSHORTNAMEANDCODE_FLOW_FAIL,
    GetCustomersShortNameAndCodeState
} from "../../domain/association/index";

export const initialState: GetCustomersShortNameAndCodeState = {
    result: []
};

export default function returnCustomerCode(state = initialState, action: any) {
    switch (action.type) {
        case START_CUSTOMERSSHORTNAMEANDCODE_FLOW:
            return {
                ...state,
                result: action.payload
            };
        case START_CUSTOMERSSHORTNAMEANDCODE_FLOW_FAIL:
            return { ...state, result: action.payload };
        default:
            return state;
    }
};
